import { getPortalToken, clearPortalSession, PORTAL_LOGIN_PATH } from "./auth";
import { getApiBase } from "./portalApiBase";

export { getApiBase, portalApiUrl } from "./portalApiBase";

export async function api(path, options = {}) {
  const { ...fetchOptions } = options;
  const token = getPortalToken();
  const headers = {
    "Content-Type": "application/json",
    ...(fetchOptions.headers || {}),
  };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${getApiBase()}${path}`, {
    credentials: "include",
    ...fetchOptions,
    headers,
  });

  if (
    res.status === 401 &&
    typeof window !== "undefined" &&
    window.location.pathname.startsWith("/nyafaz-portal/") &&
    window.location.pathname !== "/nyafaz-portal"
  ) {
    clearPortalSession();
    window.location.assign(PORTAL_LOGIN_PATH);
  }

  return res;
}
